import { useQuery } from '@tanstack/react-query';
import type AgentApiAllianceApplicationsIndex from '@/types/serializers/AgentApiAllianceApplicationsIndex';

export const AGENT_ALLIANCE_APPLICATIONS_QUERY_KEY = ['agent_alliance_applications'] as const;

export type AllianceSortOrder = 'updated_at_desc' | 'applied_at_desc' | 'applied_at_asc';

export default function useFetchAgentAllianceApplications(params?: {
  page?: number;
  status?: string;
  q?: string;
  sort?: AllianceSortOrder;
  agentId?: string;
}) {
  return useQuery({
    queryKey: [
      ...AGENT_ALLIANCE_APPLICATIONS_QUERY_KEY,
      params?.page ?? 1,
      params?.status ?? 'all',
      params?.q ?? '',
      params?.sort ?? 'updated_at_desc',
      params?.agentId ?? '',
    ],
    queryFn: async () => {
      const searchParams = new URLSearchParams();
      if (params?.page) searchParams.set('page', String(params.page));
      if (params?.status && params.status !== 'all') searchParams.set('status', params.status);
      if (params?.q) searchParams.set('q', params.q);
      if (params?.sort && params.sort !== 'updated_at_desc') searchParams.set('sort', params.sort);
      if (params?.agentId) searchParams.set('agent_id', params.agentId);
      const queryString = searchParams.toString();
      const response = await fetch(
        `/agent/api/alliance_applications${queryString ? `?${queryString}` : ''}`
      );
      if (!response.ok) {
        throw new Error('応募一覧の取得に失敗しました');
      }
      const data: AgentApiAllianceApplicationsIndex = await response.json();
      return data;
    },
  });
}
